import { Stack, Typography } from "@mui/material";
import { Box } from "@mui/system";

type PMinMaxField = {
    min: any;
    max: any;
};

export default function MinMaxField(props: PMinMaxField) {
    return (
        <Stack direction="column" minWidth="200px" m={1}>
            <Stack direction="row">
                <Typography fontSize="small" fontWeight="bold" minWidth="30px">
                    Min
                </Typography>
                <Typography fontSize="small">{parseFloat(props.min).toFixed(3)}</Typography>
            </Stack>
            <Stack direction="row">
                <Typography fontSize="small" fontWeight="bold" minWidth="30px">
                    Max
                </Typography>
                <Typography fontSize="small">{parseFloat(props.max).toFixed(3)}</Typography>
            </Stack>
        </Stack>
    );
}
